import { render, staticRenderFns } from "./snackbar.vue?vue&type=template&id=e4877e70&scoped=true&"
import script from "./snackbar.vue?vue&type=script&lang=js&"
export * from "./snackbar.vue?vue&type=script&lang=js&"
import style0 from "./snackbar.vue?vue&type=style&index=0&id=e4877e70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4877e70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4877e70')) {
      api.createRecord('e4877e70', component.options)
    } else {
      api.reload('e4877e70', component.options)
    }
    module.hot.accept("./snackbar.vue?vue&type=template&id=e4877e70&scoped=true&", function () {
      api.rerender('e4877e70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/snackbar.vue"
export default component.exports